import InternalAdminLogo from '@/assets/icons/InternalAdminLogo';
import COLORS from '@/constants/colors';
import { AppBar, Box, Toolbar } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RequestNewPasswordForm } from './RequestNewPasswordForm';

export const RequestNewPasswordContainer = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <AppBar
        sx={{
          backgroundColor: COLORS.white,
          boxShadow: 0,
        }}
      >
        <Toolbar>
          <Box
            onClick={() => navigate('/seller/login')}
            sx={{ cursor: 'pointer' }}
          >
            <InternalAdminLogo />
          </Box>
        </Toolbar>
      </AppBar>
      <RequestNewPasswordForm />
    </Box>
  );
};
